import {Directive, ElementRef, HostListener} from '@angular/core';
import {NgControl} from '@angular/forms';

@Directive({
  selector: '[appNumber]'
})
export class NumberDirective {
  private readonly regex: RegExp = new RegExp(/^[1-9]+([0-9]*){0,1}$/g);
  private current: string;
  private readonly specialKeys: Array<string> = [
    'Escape',
    'Backspace',
    'Tab',
    'End',
    'Home',
    'Enter',
    'ArrowRight',
    'ArrowLeft',
    'ArrowUp',
    'ArrowDown',
    'Delete',
    'Del',
    'Right',
    'Left',
    'Up',
    'Down',
    'Alt',
    'Shift'
  ];

  constructor(
    private readonly el: ElementRef,
    private readonly formControl: NgControl) {
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: any) {
    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }
    this.current = this.removeSpaceChar(this.el.nativeElement.value);
    const next: string = this.current.concat(event.key);

    const key = event.which || event.keyCode; // keyCode detection
    const ctrl = event.ctrlKey ? event.ctrlKey : key === 17; // ctrl detection

    if (key === 86 && ctrl) { // Ctrl+V (Paste)
      return;
    } else if (key === 67 && ctrl) { // Ctrl+C (Copy)
      return;
    } else if (next && !String(next).match(this.regex)) {
      event.preventDefault();
    }
  }

  @HostListener('input', ['$event'])
  onInput() {
    this.el.nativeElement.value = this.removeSpaceChar(this.el.nativeElement.value);
    const value: string = this.el.nativeElement.value;
    if (value && !String(value).match(this.regex)) {
      this.el.nativeElement.value = this.current;

      this.setValue(this.current);
      this.el.nativeElement.setSelectionRange(0, 0);
    }
  }

  @HostListener('copy', ['$event'])
  onCopy(e: any) {
    const value = this.el.nativeElement.value;
    e.clipboardData.setData('text/plain', value);
    e.preventDefault();
  }

  @HostListener('paste', ['$event'])
  onPaste(e: any) {
    const clipboardValue = e.clipboardData.getData('text/plain');
    // Blev tvungen att omvandla input värdet från string till number för att ta bort alla specialtecken.
    const trimmedClipboardValue = +this.removeSpaceChar(clipboardValue);
    if (isNaN(trimmedClipboardValue) && !this.regex.test(trimmedClipboardValue.toString())) {
      return false;
    }

    if (this.isValueLenghtLesserThanMaxLength(trimmedClipboardValue, this.el.nativeElement.maxLength)) {
      this.setValue(trimmedClipboardValue.toString());
      this.triggerChangeEvent();
    }
    return false;
  }

  @HostListener('drop', ['$event'])
  onDrop(event: any) {
    event.preventDefault();
  }

  private removeSpaceChar(str: string): string {
    return str.replace(/\s/g, '');
  }

  private isValueLenghtLesserThanMaxLength(strLength, maxLength): boolean {
    return strLength.toString().length <= maxLength;
  }

  private setValue(value: string): void {
    this.el.nativeElement.value = null;
    this.el.nativeElement.value = value;
    this.formControl.control.setValue(value);
  }

  private triggerChangeEvent(): void {
    const event = new Event('change');
    this.el.nativeElement.dispatchEvent(event);
  }
}
